import request from "@/core/services/request";

export function getBuyMessage(params) {
  return request({
    url: "/api/v1/web/buy/message/",
    method: "get",
    params: params,
  });
}

export function getIp() {
  return request({
    url: "/api/v1/ip/",
    method: "get",
  });
}

export function getWebDashBoardMessage(params) {
  return request({
    url: "/api/v1/web/expend/dashboard/",
    method: "get",
    params: params,
  });
}

export function fetchBuyMessage() {
  return getBuyMessage().then((res) => {
    res.result.pay_channels.forEach((channel) => {
      if (channel.type === "weixin") {
        channel.html = '<i class="socicon-wechat text-success icon-2x"></i>';
      } else if (channel.type === "alipay") {
        channel.html = '<i class="fab la-alipay icon-2x"></i>';
      } else {
        channel.html = "";
      }
    });
    return res;
  });
}
